//应该也没有用了
import React from 'react'
import {
  Spin,
  message,
  Input,
  Tabs,
  Button,
  Tooltip,
  DatePicker,
  Divider,
  Select,
  Modal,
  Upload,
  Result,
  BackTop,
  Popconfirm
} from 'antd'
import styles from './commodity-qualification.module.less'
import common from '@/public/common'
import { ajaxApi } from '@/server/index'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { getCookie, getParmUrl, getCookieNew,uploadErrHandle,tokenConfig } from '@/public/utils'
import _lodash from 'lodash'
import HistoryComponent from './historycomponent'
import ManufacturerComponent from './manufacturercomponent'
import {
  CloseCircleOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  PlusOutlined,
  UploadOutlined,
  WarningOutlined
} from '@ant-design/icons'
const { TabPane } = Tabs
const { Option } = Select
const { TextArea } = Input
const _urlLink = common.newUrl
// 接口文档：http://confluence.vsigo.cn/pages/viewpage.action?pageId=62757811
// 产品文档：https://lanhuapp.com/url/jbUIt
class ManufacturerDetail extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      postData: {
        vender_id: getParmUrl('VenderID') ? getParmUrl('VenderID') * 1 : null

      },
      tabActiveKey: '0',
      qualificationsData: [], // 商品资质
      cloneQualificationsData: [], // 克隆的商品资质
      agencyqualificationData: [], // 代理商资质
      sixFaceData: [], // 六面型的数据
      testUrl: window.location.host.split('t').length - 1 === 1,
      editData: {
        item_id: null,
        qua_item_id: null,
        action: '',
        editer: getCookie('adminName')
          ? JSON.parse(getCookie('adminName')).UserID
          : getCookie('otheradminName')
            ? JSON.parse(getCookie('otheradminName')).UserID
            : '',
        //  editer: 2132,
        qua_category: '',
        note: '',
        vender_id: null,
        details: []
      },
      modalTitle: '', // 弹框内容
      visible: false,
      btnLoadings: {
        preservationLoading: false, // 保存
        submitLoading: false, // 提交
        agreeLoading: false, // 同意
        okLoading: false, // 确定
        finalpassLoading: false, // 终审通过
        backEditLoading: false // 返回修改
      },
      detailsVisible: false,
      detailsParam: {
        item_id: null,
        qua_item_id: null,
        itme_name: '',
        vender_id: null,
        qua_category: ''
      },
      type: '',
      chooseDetails: false, // 选择厂商的弹框
      chooseFirmParam: {
        qua_category: '',
        name: '',
        page_index: 1,
        page_size: 10
      },
      overdueData: [], // 过期资质数据
      historyData: [], // 历史资质数据
      waringData: [], // 预警资质
      quaCategory: 'Item',
      agentEditPost: {
        qua_id: null,
        item_id: null,
        qua_item_id: null,
        action: '',
        editer: getCookie('adminName')
          ? JSON.parse(getCookie('adminName')).UserID
          : getCookie('otheradminName')
            ? JSON.parse(getCookie('otheradminName')).UserID
            : '',
        // editer: 2132,
        note: '',
        details: [],
        delete_ids: []
      },
      approvalStatus: null,
      Imagevisible: false,
      lookImageList: [],
      sixfacehide: true,
      ruleIdArr: getCookieNew('scsruleidarr') ? getCookieNew('scsruleidarr') : [],
      qualificationsArr: [],
      noResult: false
    }
  }

  componentDidMount () {
    this.getItemQuaData()
  }

  // 资质图片和文件数据重构
  publicQuaFun =(data) => {
    let _data = data
    _data.forEach((item) => {
      if (item.qua_value.length !== 0) {
        item.qua_value.forEach((item2) => {
          if (item2.length !== 0) {
            item2.forEach((item3) => {
              if (item3.qua_filed_type === 'Picture') {
                let _imageList = []
                item3.qua_filed_value.forEach((item4, index4) => {
                  _imageList.push({
                    uid: 0 - index4.toString(),
                    name: 'image.png',
                    response: { url: item4 },
                    status: 'done',
                    url: common.imageUrl+'po/qua/image/' + item4
                  })
                })
                item3.imgList = _imageList
              } else if (item3.qua_filed_type === 'File') {
                let _fileList = []
                item3.qua_filed_value.forEach((item4, index4) => {
                  _fileList.push({
                    uid: index4.toString(),
                    name: item4,
                    response: { url: item4 },
                    status: 'done',
                    url: common.imageUrl+'po/qua/file/' + item4
                  })
                })
                item3.fileListNew = _fileList
              } else {
                return item3
              }
            })
          }
        })
      }
    })
    return _data
  }
  // 获取厂商资质的信息
  getItemQuaData = async () => {
    let { postData } = this.state
    this.setState({
      loading: true
    })
    try {
      let res = await ajaxApi({
        url: _urlLink + 'charge/query-vender-qua',
        params: postData
      })
      this.setState({
        loading: false
      })
      if (res.status === 200) {
        if (res.data) {
          if (res.data.is_have_data === 0) {
            this.setState({
              noResult: true
            })
          } else {
            if (res.data.now_data.length !== 0) {
              let _qualificationsArr = []
              let _data = res.data.now_data
              let _cloneQualificationsData = JSON.parse(JSON.stringify(_data))
              let _cloneData = JSON.parse(JSON.stringify(_data)).filter(
                (item) => item.qua_category_key === 'Agent'
              )
              let _sixFaceData = JSON.parse(JSON.stringify(_data)).filter(
                (item) => item.qua_category_key === 'SixFace'
              )
              let _dataNew = _data.filter(
                (item) => item.qua_category_key !== 'Agent'
              )
              _dataNew = _dataNew.filter(
                (item) => item.qua_category_key !== 'SixFace'
              )
              _qualificationsArr = JSON.parse(JSON.stringify(_dataNew))
              if (_cloneData !== 0) {
                _cloneData.map((item) => {
                  _qualificationsArr.push(item)
                })
              }
              if (_sixFaceData.length !== 0) {
                _sixFaceData.map((item) => {
                  _qualificationsArr.push(item)
                })
              }
              this.setState(
                {
                  qualificationsData: this.publicQuaFun(_dataNew),
                  agencyqualificationData: _cloneData,
                  sixFaceData: _sixFaceData,
                  qualificationsArr: _qualificationsArr,
                  cloneQualificationsData: _cloneQualificationsData,
                  approvalStatus: res.data.status
                })
            } else {
              this.setState({
                qualificationsData: [],
                agencyqualificationData: [],
                sixFaceData: [],
                cloneQualificationsData: []
              })
            }
          }
          this.setState({
            historyData: this.publicQuaFun(res.data.history_data),
            waringData: this.publicQuaFun(res.data.warning_data),
            overdueData: this.publicQuaFun(res.data.expire_data)
          })
        } else {
          this.setState({
            qualificationsData: [],
            agencyqualificationData: [],
            sixFaceData: [],
            cloneQualificationsData: [],
            approvalStatus: null
          })
        }
      }
    } catch (e) {
      this.setState({
        loading: false,
        approvalStatus: null
      })
    }
  };

  // tab切换
  tabChange = (key) => {
    let {
      quaVenderId,
      quaCategory,
      quaItemName,
      qualificationsArr
    } = this.state
    let _sixfacehide = true
    let _key = key * 1
    quaCategory = qualificationsArr[_key].qua_category_key
    quaVenderId = qualificationsArr[_key].vender_id
    quaItemName = qualificationsArr[_key].item_name
    if (
      quaCategory === 'Producer' ||
      quaCategory === 'Supplier' ||
      quaCategory === 'Service'
    ) {
      if (!quaVenderId) {
        message.warning('请选择产商', 2)
      }
    }

    if (quaCategory === 'SixFace') {
      _sixfacehide = false
    } else {
      _sixfacehide = true
    }

    this.setState(
      {
        tabActiveKey: key,
        quaVenderId,
        quaCategory,
        quaItemName,
        sixfacehide: _sixfacehide
      }
    )
  };

  // 获取编辑值得公共方法
  publicGetValue=(index) => {
    let {qualificationsData, postData, editData} = this.state
    editData.item_id = postData.item_id
    editData.qua_item_id = postData.qua_item_id
    editData.qua_category = qualificationsData[index].qua_category_key
    editData.vender_id = qualificationsData[index].vender_id

    let _arr = []
    qualificationsData[index].qua_value.forEach((value) => {
      let _obj = {}
      value.forEach((value2) => {
        _obj[value2.qua_filed_key] = value2.qua_filed_value
      })
      let _quaidIndex = _lodash.findIndex(value, (o) => {
        return o.qua_id !== null
      })
      _obj.qua_id = value[_quaidIndex] ? value[_quaidIndex].qua_id : null
      _arr.push(_obj)
    })
    editData.details = _arr
    return editData
  }

  // 获取输入框的值
  handleChangeInput = (e, index, index2, name) => {
    let { qualificationsData } = this.state
    qualificationsData[index].qua_value[index2].forEach((item) => {
      if (item.qua_filed_name === name) {
        item.qua_filed_value = e.target.value
      }
    })
    let _editData = this.publicGetValue(index)
    this.setState({
      qualificationsData,
      editData: _editData
    })
  };

  // 获取下拉框的值
  handelSelect = (e, index, index2, name) => {
    let { qualificationsData } = this.state
    qualificationsData[index].qua_value[index2].forEach((item) => {
      if (item.qua_filed_name === name) {
        item.qua_filed_value = e
      }
    })
    let _editData = this.publicGetValue(index)
    this.setState({
      qualificationsData,
      editData: _editData
    })
  };

  // 获取时间的值
  handleChangeDate = (e, index, index2, name) => {
    let { qualificationsData } = this.state
    qualificationsData[index].qua_value[index2].forEach((item) => {
      if (item.qua_filed_name === name) {
        item.qua_filed_value = e ? moment(e).valueOf() : null
      }
    })
    if (index2 === 0) {
      qualificationsData[index].qua_value.forEach((item) => {
        item.forEach((item2) => {
          if (item2.qua_filed_name === name) {
            item2.qua_filed_value = e ? moment(e).valueOf() : null
          }
        })
      })
    }

    let _editData = this.publicGetValue(index)
    this.setState({
      qualificationsData,
      editData: _editData
    })
  };

  // 图片上传
  handleChangeResponsibility = (index, index2, name, { file, fileList }) => {
    let { qualificationsData } = this.state
    let _index
    fileList = uploadErrHandle(file, fileList)
    if (file.status === 'done') {
      fileList = fileList.map((item) => {
        // 相关文件对象数据格式化处理
        return item
      })
    }
    qualificationsData[index].qua_value[index2].forEach((item, m) => {
      if (item.qua_filed_name === name) {
        _index = m
        item.imgList = fileList
      }
    })
    qualificationsData[index].qua_value[index2][_index].imgList.forEach((item) => {
      if (item.response && item.response.url) {
        item.url = common.imageUrl+'po/qua/image/' + item.response.url
        qualificationsData[index].qua_value[index2][
          _index
        ].qua_filed_value.push(item.response.url)

        qualificationsData[index].qua_value[index2][
          _index
        ].qua_filed_value = _lodash.uniqWith(
          qualificationsData[index].qua_value[index2][_index].qua_filed_value,
          _lodash.isEqual
        )
      }
    })

    let _editData = this.publicGetValue(index)
    this.setState({
      qualificationsData,
      editData: _editData
    })
  };
  // 图片预览
  handlePreviewResponsibility = (index, index2, name, file) => {
    let { qualificationsData } = this.state
    let _url = file.url || file.thumbUrl
    qualificationsData[index].qua_value[index2].forEach((item) => {
      if (item.qua_filed_name === name) {
        item.imgVisible = true
      }
    })
    this.setState({
      qualificationsData,
      imgUrl: _url
    })
  };

  // 取消
  handleCancel = (index, index2, name) => {
    let { qualificationsData } = this.state
    qualificationsData[index].qua_value[index2].forEach((item) => {
      if (item.qua_filed_name === name) {
        item.imgVisible = false
      }
    })
    this.setState({
      qualificationsData
    })
  };

  // 删除图片
  handleDeleteImg = (index, index2, name, file) => {
    let { qualificationsData, editData } = this.state
    let _index
    let _url = file.response.url
    qualificationsData[index].qua_value[index2].forEach((item, m) => {
      if (item.qua_filed_name === name) {
        _index = m
      }
    })
    qualificationsData[index].qua_value[index2][_index].qua_filed_value.forEach(
      (item, i) => {
        if (item === _url) {
          qualificationsData[index].qua_value[index2][
            _index
          ].qua_filed_value.splice(i, 1)
        }
      }
    )
    this.setState({
      qualificationsData,
      editData
    })
  };

  // 文件上传
  handleChangeFileAuthorize = (index, index2, name, { file, fileList }) => {
    let { qualificationsData } = this.state
    let _index
    // let fileList = [...info.fileList]
    // 1. 限制上载的文件数
    // 只显示两个最近上传的文件，旧文件将被新文件替换
    // fileList = fileList.slice(-2)
    // 2. 从响应读取并显示文件链接
    if (file.status === 'done') {
      fileList = fileList.map((item) => {
        // 相关文件对象数据格式化处理
        if (item.name !== item.response.url) {
          item.name = item.response.url
        }
        return item
      })
    }

    qualificationsData[index].qua_value[index2].forEach((item, m) => {
      if (item.qua_filed_name === name) {
        _index = m
        item.fileListNew = uploadErrHandle(file, fileList)
      }
    })
    qualificationsData[index].qua_value[index2][_index].fileListNew.forEach(
      (item) => {
        let _urlCode = []
        if (item.response && item.response.url) {
          item.url =
              common.imageUrl+'po/qua/file/' + item.response.url
          _urlCode.push(item.response.url)
          qualificationsData[index].qua_value[index2][
            _index
          ].qua_filed_value.push(item.response.url)
          qualificationsData[index].qua_value[index2][
            _index
          ].qua_filed_value = _lodash.uniqWith(
            qualificationsData[index].qua_value[index2][_index]
              .qua_filed_value,
            _lodash.isEqual
          )
        }
      }
    )
    let _editData = this.publicGetValue(index)
    this.setState({
      qualificationsData,
      editData: _editData
    })
  };

  // 删除文件
  handleDeleteFile = (index, index2, name, file) => {
    let { qualificationsData } = this.state
    let _index
    let _url = file.response.url

    qualificationsData[index].qua_value[index2].forEach((item, m) => {
      if (item.qua_filed_name === name) {
        _index = m
      }
    })

    qualificationsData[index].qua_value[index2][_index].qua_filed_value.forEach(
      (item, i) => {
        if (item === _url) {
          qualificationsData[index].qua_value[index2][
            _index
          ].qua_filed_value.splice(i, 1)
        }
      }
    )

    let _editData = this.publicGetValue(index)
    this.setState({
      qualificationsData,
      editData: _editData
    })
  };

  // 选择产商
  handleChooseManufacturer = (e, valueble, valuetype) => {
    let { chooseFirmParam } = this.state
    chooseFirmParam.qua_category = valuetype
    //   chooseFirmParam.name = valuename
    this.setState(
      {
        chooseFirmParam
      },
      () => {
        this.chooseManufacturerVisible(valueble)
      }
    )
  };

  // 添加代理商资质
  handleAddArgent = (e, valueble, valuetype) => {
    let { chooseFirmParam } = this.state
    chooseFirmParam.qua_category = valuetype
    //   chooseFirmParam.name = valuename
    this.setState(
      {
        chooseFirmParam
      },
      () => {
        this.chooseManufacturerVisible(valueble)
      }
    )
  };

  // 添加代理服务商传过来的值
  getAgentRecord = (record) => {
    let { agencyqualificationData } = this.state
    if (record) {
      record.agent_id = record.vender_id
      record.agent_name = record.vender_name
      agencyqualificationData[0].qua_value.push(record)
      agencyqualificationData[0].qua_value = _lodash.uniqWith(
        agencyqualificationData[0].qua_value,
        _lodash.isEqual
      )
      this.setState({
        agencyqualificationData
      })
    }
  };

  // 生产商和代理服务商
  manufacturersServiceProviders = (value) => {
    this.setState({
      tabActiveKey: value
    })
  };

  // 删除代理商
  handleDeleteAgent = (e, index) => {
    let { agencyqualificationData, agentEditPost } = this.state
    let _ids = agencyqualificationData[0].qua_value[index].agent_id
    agentEditPost.delete_ids.push(_ids)
    agencyqualificationData[0].qua_value.splice(index, 1)

    if (agentEditPost.details.length !== 0) {
      agentEditPost.details.splice(index, 1)
    }
    this.setState({
      agencyqualificationData,
      agentEditPost
    })
  };

  // 产商弹框的展示
  chooseManufacturerVisible = (value) => {
    this.setState({
      chooseDetails: value
    })
  };

  // 弹框输入框的值
  handleModalInput = (e) => {
    let { editData } = this.state
    editData.note = e.target.value
    this.setState({
      editData
    })
  };

  // 提交按钮
  handleClick = (e, actions) => {
    let {
      editData,
      btnLoadings,
      agentEditPost,
      quaCategory,
      testUrl
    } = this.state

    if (actions === 'save') {
      btnLoadings.preservationLoading = false
      editData.action = actions
      agentEditPost.action = actions
      this.setState(
        {
          editData,
          btnLoadings
        },
        () => {
          if (quaCategory === 'Agent') {
            this.publicFunAgent()
          } else {
            this.publicFun()
          }
        }
      )
    } else if (actions === 'submit') {
      btnLoadings.submitLoading = false
      editData.action = actions
      agentEditPost.action = actions
      this.setState({
        modalTitle: '变更内容',
        visible: true
      })
    } else if (actions === 'pass') {
      btnLoadings.agreeLoading = false
      editData.action = actions
      agentEditPost.action = actions
      this.setState(
        {
          editData,
          btnLoadings
        },
        () => {
          if (quaCategory === 'Agent') {
            this.publicFunAgent()
          } else {
            this.publicFun()
          }
        }
      )
    } else if (actions === 'returnback') {
      btnLoadings.backEditLoading = false
      editData.action = actions
      agentEditPost.action = actions
      this.setState({
        modalTitle: '审批意见',
        visible: true
      })
    } else if (actions === 'finalpass') {
      btnLoadings.finalpassLoading = false
      editData.action = actions
      agentEditPost.action = actions
      this.setState({
        modalTitle: '变更内容',
        visible: true
      })
    } else if (actions === 'back') {
      window.location.href = testUrl
        ? common.absolutepathqualificationlistt
        : common.absolutepathqualificationlist
    }
    this.setState({
      editData,
      btnLoadings,
      agentEditPost
    })
  };

  // 确定
  handleOk = async (e, index) => {
    let {
      editData,
      agentEditPost,
      btnLoadings,
      qualificationsData,
      agencyqualificationData,
      postData,
      quaVenderId,
      quaCategory
    } = this.state
    let _isNeed = true
    let isNeedArr = []
    let _url
    editData.item_id = postData.item_id
    editData.qua_item_id = postData.qua_item_id
    editData.qua_category = quaCategory
    editData.vender_id = quaVenderId
    // editData.editer =  JSON.parse(getCookie("AdminID"))

    if (agencyqualificationData.length !== 0) {
      agentEditPost.item_id = postData.item_id
      agentEditPost.qua_item_id = postData.qua_item_id
      agentEditPost.qua_id = agencyqualificationData[0].qua_id
      agentEditPost.note = editData.note
    }

    if (quaCategory === 'Agent') {
      if (
        agentEditPost.action === 'submit' ||
        agentEditPost.action === 'pass'
      ) {
        if (agentEditPost.note === '') {
          message.warning('请选择必填项', 1.5)
          return
        }
      }

      if (agentEditPost.details.length !== 0) {
        agentEditPost.details.map((item) => {
          if (item.begin_time === null || item.end_time === null) {
            _isNeed = false
          }
        })
      } else {
        if (agencyqualificationData[0].qua_value.length !== 0) {
          if (agencyqualificationData[0].qua_value.qua_value) {
            agencyqualificationData[0].qua_value.qua_value.map((item) => {
              if (item.begin_time === null || item.end_time === null) {
                _isNeed = false
              }
            })
          }
        }
      }

      if (!_isNeed) {
        message.warning('请选择必填项', 1.5)
        return
      }

      _url = common.scpUrl + 'item/update-agent-qua'
    } else {
      qualificationsData[index].qua_value.forEach((item) => {
        item.forEach((item2) => {
          if (item2.qua_filed_name === '资质名称') {
            if (item2.is_need === 1) {
              isNeedArr.push(item)
            }
          }
        })
      })

      if (isNeedArr.length !== 0) {
        isNeedArr.forEach((item) => {
          if (item.length !== 0) {
            item.forEach((item2) => {
              if (item2.is_need === 1) {
                if (
                  item2.qua_filed_value === '' ||
                  item2.qua_filed_value === null ||
                  item2.qua_filed_value.length === 0
                ) {
                  _isNeed = false
                }
              }
            })
          }
        })
      }
      if (!_isNeed) {
        message.warning('请选择必填项', 1.5)
        return
      }

      _url = _urlLink + 'charge/update-vender-qua'
    }

    this.setState({
      visible: true
    })
    let res = await ajaxApi({
      url: _url,
      params: quaCategory === 'Agent' ? {
        vender_id: getParmUrl('VenderID'),
        editer: agentEditPost.editer,
        details: agentEditPost.details
      } : { vender_id: getParmUrl('VenderID'),
        editer: editData.editer,
        details: editData.details}
    })
    if (res.status === 200) {
      message.success('操作成功', 1.5)
    }
    agentEditPost.note = ''
    editData.note = ''
    this.setState(
      {
        editData,
        agentEditPost,
        btnLoadings,
        visible: false,
        tabActiveKey: '0'
      },
      () => {
        this.getItemQuaData()
      }
    )
  };

  publicFun = async () => {
    let {
      editData,
      btnLoadings,
      qualificationsData,
      tabActiveKey,
      quaCategory,
      quaVenderId,
      postData
    } = this.state
    let _isNeed = true
    let isNeedArr = []
    editData.item_id = postData.item_id
    editData.qua_item_id = postData.qua_item_id
    editData.qua_category = quaCategory
    editData.vender_id = quaVenderId
    // editData.editer = JSON.parse(getCookie("AdminID"))

    qualificationsData[tabActiveKey].qua_value.forEach((item) => {
      item.forEach((item2) => {
        if (item2.qua_filed_name === '资质名称') {
          if (item2.is_need === 1) {
            isNeedArr.push(item)
          }
        }
      })
    })

    if (isNeedArr.length !== 0) {
      isNeedArr.forEach((item) => {
        if (item.length !== 0) {
          item.forEach((item2) => {
            if (item2.is_need === 1) {
              if (
                item2.qua_filed_value === '' ||
                item2.qua_filed_value === null ||
                item2.qua_filed_value.length === 0
              ) {
                _isNeed = false
              }
            }
          })
        }
      })
    }
    if (!_isNeed) {
      message.warning('请选择必填项', 1.5)
      return
    }

    let res = await ajaxApi({
      url: _urlLink + 'charge/update-vender-qua',
      params: {
        vender_id: getParmUrl('VenderID'),
        editer: editData.editer,
        details: editData.details
      }
    })
    if (res.status === 200) {
      message.success('操作成功', 1.5)
      this.setState(
        {
          editData,
          btnLoadings,
          visible: false,
          tabActiveKey: '0'
        },
        () => {
          this.getItemQuaData()
        }
      )
    }
  };

  publicFunAgent = async () => {
    let {
      agentEditPost,
      btnLoadings,
      postData,
      agencyqualificationData
    } = this.state
    let _isNeed = true
    try {
      agentEditPost.item_id = postData.item_id
      agentEditPost.qua_item_id = postData.qua_item_id
      agentEditPost.qua_id = agencyqualificationData[0].qua_id

      if (agentEditPost.details.length !== 0) {
        agentEditPost.details.map((item) => {
          if (item.begin_time === null || item.end_time === null) {
            _isNeed = false
          }
        })
      } else {
        if (agencyqualificationData[0].qua_value.length !== 0) {
          if (agencyqualificationData[0].qua_value.qua_value) {
            agencyqualificationData[0].qua_value.qua_value.map((item) => {
              if (item.begin_time === null || item.end_time === null) {
                _isNeed = false
              }
            })
          }
        }
      }

      if (!_isNeed) {
        message.warning('请选择必填项', 1.5)
        return
      }

      let res = await ajaxApi({
        url: common.scpUrl + 'item/update-agent-qua',
        params: {
          vender_id: getParmUrl('VenderID'),
          editer: agentEditPost.editer,
          details: agentEditPost.details
        }
      })
      if (res.status === 200) {
        message.success('操作成功', 1.5)
        this.setState(
          {
            agentEditPost,
            btnLoadings,
            tabActiveKey: '0'
          },
          () => {
            this.getItemQuaData()
          }
        )
      }
    } catch (e) {
      message.error(e)
    }
  };

  // 点击历史资质详情
  handleDetailes = (e, value) => {
    this.setState(
      {
        type: 'history'
      },
      () => {
        this.handleVisible(value)
      }
    )
  };

  // 点击过期资质详情
  handleOverdueQualification = (e, value) => {
    this.setState(
      {
        type: 'expired'
      },
      () => {
        this.handleVisible(value)
      }
    )
  };

  // 点击预警资质的详情
  handleWaringQualification = (e, value) => {
    this.setState(
      {
        type: 'waring'
      },
      () => {
        this.handleVisible(value)
      }
    )
  };

  // 商品查看资质的弹框展示
  handleVisible = (value) => {
    this.setState({
      detailsVisible: value
    })
  };

  // 查看代理商资质
  handleLookAgent = (e, index, index2) => {
    const { agencyqualificationData, postData } = this.state
    let itemId = postData.item_id
    let venderId = agencyqualificationData[index].qua_value[index2].agent_id
    let quaCategory = agencyqualificationData[index].qua_category_key
    window.location.href =
      '/main/commodityqualification/corresponding-manufacturer-goods?itemId=' +
      itemId +
      '&&venderId=' +
      venderId +
      '&&quaCategory=' +
      quaCategory
  };

  // 获取代理商资质的日期
  handleChangeAgentDate = (e, index, index2, name) => {
    let { agencyqualificationData, agentEditPost, postData } = this.state
    agencyqualificationData[index].qua_value[index2][name] = e
      ? moment(e).valueOf()
      : null
    agentEditPost.item_id = postData.item_id
    agentEditPost.qua_item_id = postData.qua_item_id
    agentEditPost.qua_id = agencyqualificationData[0].qua_id
    let _arr = []
    agencyqualificationData.forEach((item) => {
      if (item.qua_value !== 0) {
        item.qua_value.forEach((item2) => {
          _arr.push({
            vender_id: item2.agent_id,
            begin_time: item2.begin_time,
            end_time: item2.end_time
          })
        })
      }
    })
    agentEditPost.details = _arr
    this.setState({
      agencyqualificationData,
      agentEditPost
    })
  };

  // 弹框取消
  handleCancelModal = () => {
    let { editData } = this.state
    editData.note = ''
    this.setState({
      visible: false,
      Imagevisible: false,
      editData
    })
  };

  // 查看图片
  handleLookImages = (e, value) => {
    this.setState({
      Imagevisible: true,
      lookImageList: value
    })
  };

  // 删除自定义的图片
  handleDeleteImage = (e, index, index2, name, index3) => {
    e.stopPropagation()
    let { qualificationsData } = this.state
    let _index
    qualificationsData[index].qua_value[index2].map((item, m) => {
      if (item.qua_filed_name === name) {
        _index = m
      }
    })
    let _obj =
      qualificationsData[index].qua_value[index2][_index].imgList[index3]
        .response.url
    qualificationsData[index].qua_value[index2][_index].qua_filed_value.map(
      (value, j) => {
        if (value === _obj) {
          qualificationsData[index].qua_value[index2][
            _index
          ].qua_filed_value.splice(j, 1)
        }
      }
    )
    qualificationsData[index].qua_value[index2][_index].imgList.splice(
      index3,
      1
    )
    let _editData = this.publicGetValue(index)
    this.setState({
      qualificationsData,
      editData: _editData
    })
  };

  // 快捷复制资质
  handleQuickCopy=(e, index, index2) => {
    let {qualificationsData, waringData, overdueData} = this.state
    let _arr = []
    let _arrNew = []
    let _quafilednamevalue = ''
    let clonewaringData = JSON.parse(JSON.stringify(waringData))
    let cloneoverdueData = JSON.parse(JSON.stringify(overdueData))
    _arr = qualificationsData[index].qua_value[index2]
    if (_arr.length !== 0) {
      for (var i = 0; i < _arr.length; i++) {
        if (_arr[i].qua_filed_name === '资质名称') {
          _quafilednamevalue = _arr[i].qua_filed_value
        } else {
          _quafilednamevalue = ''
        }
      }
    }
    if (clonewaringData.length !== 0) {
      let _quavalueWarn = clonewaringData[0].qua_value
      for (let j = 0; j < _quavalueWarn.length; j++) {
        let _quavalueWarnNew = _quavalueWarn[j] || []
        _quavalueWarnNew.map((item) => {
          if (item.qua_filed_value === _quafilednamevalue) {
            _arrNew = _quavalueWarnNew
          }
          return _arrNew
        })
      }
    }
    if (cloneoverdueData.length !== 0) {
      let _quavalueOver = cloneoverdueData[0].qua_value
      for (let m = 0; m < _quavalueOver.length; m++) {
        let _quavalueOverNew = _quavalueOver[m] || []
        _quavalueOverNew.forEach((item) => {
          if (item.qua_filed_value === _quafilednamevalue) {
            let _clonQuavalueOverNew = JSON.parse(JSON.stringify(_quavalueOverNew))
            let _isQuaIdArr = _clonQuavalueOverNew.filter(
              (item2) => item2.qua_filed_name !== '资质名称'
            )
            let _index = _lodash.findIndex(_isQuaIdArr, (item3) => {
              return item3.qua_id !== null
            })
            if (clonewaringData.length !== 0) {
              if (_index !== -1) {
                _arrNew = _quavalueOverNew
              }
            } else {
              _arrNew = _quavalueOverNew
            }
          }
          return _arrNew
        })
      }
    }
    qualificationsData[index].qua_value[index2] = _arrNew
    this.setState({
      qualificationsData
    })
  }

  render () {
    let {
      qualificationsData,
      agencyqualificationData,
      btnLoadings,
      overdueData,
      waringData,
      lookImageList,
      sixFaceData,
      editData,
      quaCategory,
      quaVenderId,
      noResult
    } = this.state
    const uploadButton = (
      <div style={{ position: 'relative' }}>
        <PlusOutlined />
        <div className="ant-upload-text">上传</div>
      </div>
    )

    return (
      <div>
        <Spin spinning={this.state.loading}>
          <h2>
            <span style={{ fontSize: '16px' }}>
              质量管理 /监管类别/厂商资质
            </span>
          </h2>
          <Divider />
          {
            noResult
              ? <Result
                status="warning"
                title="暂未查询到相关资质信息，请刷新当前页面或返回新增"
                extra={
                  <Button type="primary"
                    onKeyDown={this.onKeyup}
                    onClick={(e) => this.handleClick(e, 'back')}
                    key="console">
                  返回
                  </Button>
                }
              />
              : <div>
                <Tabs
                  onChange={this.tabChange}
                  type="line"
                  className={styles.tableBox}
                  activeKey={this.state.tabActiveKey}
                >
                  {qualificationsData
                    ? qualificationsData.map((item, index) => {
                      return (
                        <TabPane
                          tab={item.qua_category_name}
                          onChange={this.handleTabPane}
                          key={index}
                        >
                          <div
                            style={{
                              fontSize: '20px',
                              color: 'red',
                              marginBottom: '24px'
                            }}
                          >
                            <span>厂商名称：</span>
                            <span style={{ marginRight: '8px' }}>
                              {item.supplier_name ? item.supplier_name : '--'}
                            </span>
                            <Tooltip title="点击显示预警资质（距离结束时间小于等于60天）">
                              <span style={{ fontSize: '24px' }}>
                                <ExclamationCircleOutlined
                                  onClick={(e) =>
                                    this.handleWaringQualification(e, true)
                                  }
                                  style={{
                                    color: 'coral',
                                    display:
                                    waringData.length !== 0
                                      ? 'inline-block'
                                      : 'none',
                                    marginRight: '8px'
                                  }}
                                  type="exclamation-circle"
                                  theme="filled"
                                /><span style={{display: waringData.length !== 0 ? 'inline-block' : 'none', fontSize: '12PX'}}>（查看预警资质）</span>
                              </span>
                            </Tooltip>

                            <Tooltip title="点击显示过期资质">
                              <span
                                style={{
                                  fontSize: '24px',
                                  color: ''
                                }}
                              >
                                <span>
                                  <WarningOutlined
                                    onClick={(e) =>
                                      this.handleOverdueQualification(e, true)
                                    }
                                    style={{
                                      color: 'red',
                                      display:
                                      overdueData.length !== 0
                                        ? 'inline-block'
                                        : 'none'
                                    }}
                                    type="warning"
                                    theme="filled"
                                  /><span style={{display: overdueData.length !== 0 ? 'inline-block' : 'none', fontSize: '12PX'}}>（查看过期资质）</span>
                                </span>{' '}
                              </span>
                            </Tooltip>
                          </div>
                          {item.qua_value
                            ? item.qua_value.map((item2, index2) => {
                              let _item2 = _lodash.filter(item2, (value) => {
                                return (
                                  value !== null &&
                                  value.qua_filed_name === '资质名称'
                                )
                              })
                              let _dataItemData = _lodash.filter(
                                item2,
                                (value) => {
                                  return (
                                    value !== null &&
                                    (value.qua_filed_name === '开始时间' ||
                                      value.qua_filed_name === '结束时间')
                                  )
                                }
                              )
                              let _item2New = _lodash.filter(item2, (value) => {
                                return (
                                  value !== null &&
                                  value.qua_filed_name !== '资质名称' &&
                                  value.qua_filed_name !== '开始时间' &&
                                  value.qua_filed_name !== '结束时间'
                                )
                              })

                              let isCopy = false
                              let _queIdArr = _lodash.filter(item2, (value) => {
                                return (
                                  value !== null && value.qua_id !== null
                                )
                              })
                              let _queIdArrNew = []
                              _queIdArr.forEach((itemNew) => {
                                if (itemNew.qua_filed_value !== null && itemNew.qua_filed_value !== '' && itemNew.qua_filed_value.length !== 0) {
                                  _queIdArrNew.push(itemNew)
                                }
                              })
                              if (waringData.length !== 0 || overdueData.length !== 0) {
                                if (_queIdArrNew.length !== 0) {
                                  isCopy = true
                                } else {
                                  isCopy = false
                                }
                              } else {
                                isCopy = true
                              }

                              // console.log(_dataItemData)
                              return (
                                <div
                                  key={index2}
                                  style={{
                                    display:
                                      quaCategory === 'Producer' ||
                                      quaCategory === 'Supplier' ||
                                      quaCategory === 'Service'
                                        ? quaVenderId
                                          ? 'flex'
                                          : 'none'
                                        : 'flex',
                                    flexWrap: 'wrap',
                                    border: '1px solid lavender',
                                    marginBottom: '24px',
                                    padding: '16px 16px',
                                    position: 'relative'
                                  }}
                                >
                                  <Popconfirm title="是否从预警或者过期中快捷复制对应的资质" onConfirm={(e) => this.handleQuickCopy(e, index, index2)} okText="是" cancelText="否">
                                    <a style={{position: 'absolute', right: '1%', top: '2%', display: isCopy ? 'none' : 'inline-block'}}>快捷复制资质</a>
                                  </Popconfirm>
                                  <div
                                    style={{
                                      width: '49%',
                                      marginBottom: '16px',
                                      lineHeight: '24px'
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        textAlign: 'right',
                                        width: '112px',
                                        float: 'left'
                                      }}
                                    >
                                      <span style={{ color: 'red' }}>*</span>
                                      资质名称：
                                    </span>
                                    <span
                                      style={{
                                        fontSize: '24px',
                                        fontWeight: 700,
                                        lineHeight: '24px',
                                        marginRight: '2%'
                                      }}
                                    >
                                      {_item2[0].qua_filed_value}
                                    </span>{' '}
                                  </div>
                                  <div
                                    style={{
                                      width: '49%',
                                      marginBottom: '16px',
                                      lineHeight: '24px',
                                      display:
                                        _dataItemData &&
                                        _dataItemData.length !== 0
                                          ? 'inline-block'
                                          : 'none'
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        textAlign: 'right',
                                        width: '112px'
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: 'red',
                                          display:
                                            _dataItemData &&
                                            _dataItemData.length !== 0
                                              ? _dataItemData[0].is_need === 1
                                                ? 'inline-block'
                                                : 'none'
                                              : 'none'
                                        }}
                                      >
                                        *
                                      </span>
                                      有效时间：
                                    </span>
                                    {_dataItemData
                                      ? _dataItemData.map((m, n) => {
                                        return (
                                          <DatePicker
                                            onOpenChange={
                                              this.handleOpenChange
                                            }
                                            key={n}
                                            format="YYYY-MM-DD"
                                            style={{
                                              width: '144px',
                                              marginRight: '8px',
                                              verticalAlign: 'middle'
                                            }}
                                            onPanelChange={
                                              this.handlePanelChange
                                            }
                                            onChange={(e) =>
                                              this.handleChangeDate(
                                                e,
                                                index,
                                                index2,
                                                m.qua_filed_name
                                              )
                                            }
                                            value={
                                              m.qua_filed_value
                                                ? moment(
                                                  m.qua_filed_value * 1
                                                )
                                                : null
                                            }
                                          />
                                        )
                                      })
                                      : null}
                                  </div>
                                  {_item2New
                                    ? _item2New.map((item3, index3) => {
                                      return (
                                        <div
                                          key={index3}
                                          style={{
                                            width: '49%',
                                            marginBottom: '16px'
                                          }}
                                        >
                                          <div>
                                            <span
                                              style={{
                                                display: 'inline-block',
                                                textAlign: 'right',
                                                width: '112px',
                                                float:
                                                    item3.qua_filed_type ===
                                                    'Picture'
                                                      ? 'left'
                                                      : 'none'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  color: 'red',
                                                  display:
                                                      item3.is_need === 1
                                                        ? 'inline-block'
                                                        : 'none'
                                                }}
                                              >
                                                  *
                                              </span>
                                              {item3.qua_filed_name + '：'}
                                            </span>
                                            {item3.qua_filed_type ===
                                              'Text' ? (
                                                <span>
                                                  {' '}
                                                  <Input
                                                    placeholder="请输入"
                                                    value={
                                                      item3.qua_filed_value
                                                        ? item3.qua_filed_value
                                                        : ''
                                                    }
                                                    onChange={(e) =>
                                                      this.handleChangeInput(
                                                        e,
                                                        index,
                                                        index2,
                                                        item3.qua_filed_name
                                                      )
                                                    }
                                                    style={{
                                                      width: 272,
                                                      marginRight: '8px',
                                                      verticalAlign: 'middle'
                                                    }}
                                                  />
                                                </span>
                                              ) : item3.qua_filed_type ===
                                                'Picture' ? (
                                                  <span
                                                    style={{
                                                      display: 'flex'
                                                    // width: "7%",
                                                    // position:'relative'
                                                    }}
                                                    className={styles.uploadimg}
                                                  >
                                                    <span
                                                      style={{
                                                        display: 'inline-block',
                                                        flexWrap: 'nowrap',
                                                        maxWidth: '416PX',
                                                        height: '104px',
                                                        overflowX: 'auto',
                                                        overflowY: 'hidden',
                                                        whiteSpace: 'nowrap'
                                                      }}
                                                    >
                                                      {item3.imgList
                                                        ? item3.imgList.map(
                                                          (j, k) => {
                                                            return (
                                                              <span
                                                                key={k}
                                                                style={{
                                                                  width:
                                                                    '104px',
                                                                  height:
                                                                    '104px',
                                                                  display:
                                                                    'inline-block',
                                                                  marginRight:
                                                                    '4px',
                                                                  border:
                                                                    '1px solid darkgray',
                                                                  position:
                                                                    'relative'
                                                                }}
                                                              >
                                                                <span
                                                                  className={
                                                                    styles.imgstyle
                                                                  }
                                                                >
                                                                  <a
                                                                    href={j.url}
                                                                    className={
                                                                      styles.iconstyle
                                                                    }
                                                                    style={{
                                                                      color:
                                                                        'white'
                                                                    }}
                                                                    target="_blank"
                                                                  >
                                                                    <EyeOutlined />
                                                                  </a>
                                                                  <CloseCircleOutlined
                                                                    className={
                                                                      styles.iconstyles
                                                                    }
                                                                    style={{position: 'absolute', top: '-4px', right: '-6px'}}
                                                                    onClick={(
                                                                      e
                                                                    ) =>
                                                                      this.handleDeleteImage(
                                                                        e,
                                                                        index,
                                                                        index2,
                                                                        item3.qua_filed_name,
                                                                        k
                                                                      )
                                                                    }
                                                                    type="close-circle"
                                                                  />{' '}
                                                                </span>
                                                                <img
                                                                  src={j.url}
                                                                  style={{
                                                                    width:
                                                                      '100%',
                                                                    height:
                                                                      '100%'
                                                                  }}
                                                                ></img>
                                                              </span>
                                                            )
                                                          }
                                                        )
                                                        : null}
                                                    </span>
                                                    <Upload
                                                      action={common.scpUrl + 'item/upload-image'}
                                                      headers={{...tokenConfig}}
                                                      listType="picture-card"
                                                      multiple={true}
                                                      accept="image/jpeg,image/jpg,image/png"
                                                      fileList={
                                                        item3.imgList
                                                          ? item3.imgList
                                                          : []
                                                      }
                                                      beforeUpload={
                                                        this
                                                          .handleBeforeUploadResponsibility
                                                      }
                                                      onChange={(e) => {
                                                        this.handleChangeResponsibility(
                                                          index,
                                                          index2,
                                                          item3.qua_filed_name,
                                                          e
                                                        )
                                                      }}
                                                      onRemove={(e) =>
                                                        this.handleDeleteImg(
                                                          index,
                                                          index2,
                                                          item3.qua_filed_name,
                                                          e
                                                        )
                                                      }
                                                    >
                                                      {item3.imgList
                                                        ? item3.imgList.length >
                                                        10
                                                          ? null
                                                          : uploadButton
                                                        : uploadButton}
                                                    </Upload>

                                                    {/* <Modal
                                                    visible={item3.imgVisible}
                                                    footer={null}
                                                    onCancel={(e)=>this.handleCancel(
                                                      index,
                                                      index2,
                                                      item3.qua_filed_name,)}
                                                  >
                                                      <img
                                                      alt="example"
                                                      style={{ width: "100%" }}
                                                      src={this.state.imgUrl}
                                                    />
                                                    </Modal> */}

                                                    <span
                                                      style={{
                                                        display:
                                                        item3.imgList.length > 4
                                                          ? 'flex'
                                                          : 'none',
                                                        alignItems: 'center',
                                                        width: '10%'
                                                      }}
                                                    >
                                                      <a
                                                        onClick={(e) =>
                                                          this.handleLookImages(
                                                            e,
                                                            item3.imgList
                                                          )
                                                        }
                                                        style={{ width: '100%' }}
                                                      >
                                                      更多
                                                      </a>
                                                    </span>
                                                  </span>
                                                ) : item3.qua_filed_type ===
                                                'File' ? (
                                                    <span
                                                      className={styles.filestyle}
                                                    >
                                                      <Upload
                                                        action={common.scpUrl + 'item/upload-image'}
                                                        headers={{...tokenConfig}}
                                                        accept=".pdf"
                                                        onChange={(e) =>
                                                          this.handleChangeFileAuthorize(
                                                            index,
                                                            index2,
                                                            item3.qua_filed_name,
                                                            e
                                                          )
                                                        }
                                                        onRemove={(e) =>
                                                          this.handleDeleteFile(
                                                            index,
                                                            index2,
                                                            item3.qua_filed_name,
                                                            e
                                                          )
                                                        }
                                                        fileList={
                                                          item3.fileListNew
                                                            ? item3.fileListNew
                                                            : []
                                                        }
                                                      >
                                                        <Button>
                                                          <UploadOutlined />
                                                      上传文件
                                                        </Button>
                                                        <span
                                                          style={{
                                                            display: 'inline-block',
                                                            marginLeft: '8px',
                                                            color: '#cccccc'
                                                          }}
                                                        >
                                                      仅支持扩展名：.pdf
                                                        </span>
                                                      </Upload>
                                                    </span>
                                                  ) : item3.qua_filed_type ===
                                                'Select' ? (
                                                      <span>
                                                        <Select
                                                          showSearch
                                                          // mode="multiple"
                                                          style={{
                                                            width: 272,
                                                            marginRight: '8px',
                                                            verticalAlign: 'middle'
                                                          }}
                                                          optionFilterProp="children"
                                                          placeholder="请选择"
                                                          value={
                                                            item3.qua_filed_value
                                                          }
                                                          onChange={(e) =>
                                                            this.handelSelect(
                                                              e,
                                                              index,
                                                              index2,
                                                              item3.qua_filed_name
                                                            )
                                                          }
                                                        >
                                                          <Option key={0} value={0}>
                                                      不校验
                                                          </Option>
                                                          <Option key={1} value={1}>
                                                      强校验
                                                          </Option>
                                                        </Select>
                                                      </span>
                                                    ) : null}
                                          </div>
                                        </div>
                                      )
                                    })
                                    : null}
                                </div>
                              )
                            })
                            : null}
                          <div
                            style={{
                              display:
                              quaCategory === 'Producer' ||
                              quaCategory === 'Supplier' ||
                              quaCategory === 'Service'
                                ? quaVenderId
                                  ? 'block'
                                  : 'none'
                                : 'block'
                            }}
                          >
                            <span style={{ fontSize: '24px' }}>
                            历史使用过资质：
                            </span>
                            <a onClick={(e) => this.handleDetailes(e, true)}>
                            查看历史资质
                            </a>
                          </div>
                        </TabPane>
                      )
                    })
                    : null}
                  {agencyqualificationData
                    ? agencyqualificationData.map((item, index) => {
                      return (
                        <TabPane
                          tab={item.qua_category_name}
                          key={qualificationsData.length}
                        >
                          <div
                            key={index}
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              border: '1px solid lavender',
                              marginBottom: '24px',
                              padding: '16px 16px'
                            }}
                          >
                            <div
                              style={{
                                width: '49%'
                              }}
                            >
                              <span
                                style={{
                                  display: 'inline-block',
                                  textAlign: 'right',
                                  width: '224px',
                                  float: 'left'
                                }}
                              >
                                {item.qua_item_key
                                  ? item.qua_item_key + '：'
                                  : '-'}
                              </span>
                              <span>
                                {item.qua_item_value ? item.qua_item_value : '--'}
                              </span>
                            </div>

                            <div
                              style={{
                                width: '49%'
                              }}
                            >
                              <span
                                style={{
                                  display: 'inline-block',
                                  textAlign: 'right',
                                  width: '112px',
                                  float: 'left'
                                }}
                              >
                              有效期：
                              </span>
                              <span>
                                {item.begin_time
                                  ? moment(item.begin_time * 1).format(
                                    'YYYY-MM-DD'
                                  )
                                  : '--'}
                              </span>
                              <span style={{ margin: '0px 8px' }}>至</span>
                              <span>
                                {item.end_time
                                  ? moment(item.end_time * 1).format('YYYY-MM-DD')
                                  : '--'}
                              </span>
                            </div>
                          </div>

                          {item.qua_value && item.qua_value.length !== 0
                            ? item.qua_value.map((item2, index2) => {
                              return (
                                <div
                                  key={index2}
                                  style={{
                                    border: '1px solid lavender',
                                    marginBottom: '24px',
                                    padding: '16px 16px',
                                    position: 'relative'
                                  }}
                                >
                                  <a
                                    onClick={(e) =>
                                      this.handleDeleteAgent(e, index2)
                                    }
                                    style={{
                                      position: 'absolute',
                                      top: '6%',
                                      right: '1%'
                                    }}
                                  >
                                    删除
                                  </a>
                                  <div style={{ padding: '8px 0px' }}>
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        textAlign: 'right',
                                        width: '112px',
                                        float: 'left'
                                      }}
                                    >
                                      代理商名称：
                                    </span>
                                    <span>
                                      {item2.agent_name
                                        ? item2.agent_name
                                        : '-'}
                                    </span>
                                    <a
                                      style={{ marginLeft: '24px' }}
                                      onClick={(e) =>
                                        this.handleLookAgent(e, index, index2)
                                      }
                                    >
                                      查看代理商资质
                                    </a>
                                  </div>

                                  <div style={{ padding: '8px 0px' }}>
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        textAlign: 'right',
                                        width: '112px',
                                        float: 'left'
                                      }}
                                    >
                                      <span style={{ color: 'red' }}>*</span>
                                      代理有效期：
                                    </span>
                                    <span>
                                      <DatePicker
                                        onOpenChange={this.handleOpenChange}
                                        format="YYYY-MM-DD"
                                        style={{ width: '144px' }}
                                        onPanelChange={this.handlePanelChange}
                                        onChange={(e) =>
                                          this.handleChangeAgentDate(
                                            e,
                                            index,
                                            index2,
                                            'begin_time'
                                          )
                                        }
                                        value={
                                          item2.begin_time
                                            ? moment(item2.begin_time * 1)
                                            : null
                                        }
                                      />
                                      <span style={{ margin: '0px 8px' }}>
                                        至
                                      </span>
                                      <DatePicker
                                        onOpenChange={this.handleOpenChange}
                                        format="YYYY-MM-DD"
                                        style={{ width: '144px' }}
                                        onPanelChange={this.handlePanelChange}
                                        onChange={(e) =>
                                          this.handleChangeAgentDate(
                                            e,
                                            index,
                                            index2,
                                            'end_time'
                                          )
                                        }
                                        value={
                                          item2.end_time
                                            ? moment(item2.end_time * 1)
                                            : null
                                        }
                                      />
                                    </span>
                                  </div>
                                </div>
                              )
                            })
                            : null}
                          <div>
                            <Button
                              type="primary"
                              onClick={(e) =>
                                this.handleAddArgent(
                                  e,
                                  true,
                                  item.qua_category_key
                                )
                              }
                            >
                            添加代理商
                            </Button>
                          </div>
                        </TabPane>
                      )
                    })
                    : null}
                  {sixFaceData || sixFaceData.length !== 0
                    ? sixFaceData.map((item, index) => {
                      let _m =
                      agencyqualificationData.length +
                      qualificationsData.length
                      return (
                        <TabPane tab={item.qua_category_name} key={_m}>
                          <div
                            key={index}
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              border: '1px solid lavender',
                              marginBottom: '24px',
                              padding: '16px 16px'
                            }}
                          >
                            <div
                              style={{
                                width: '49%'
                              }}
                            >
                              <span
                                style={{
                                  display: 'inline-block',
                                  textAlign: 'right',
                                  width: '224px',
                                  float: 'left'
                                }}
                              >
                                {item.qua_item_key
                                  ? item.qua_item_key + '：'
                                  : '-'}
                              </span>
                              <span>
                                {item.qua_item_value ? item.qua_item_value : '--'}
                              </span>
                            </div>

                            <div
                              style={{
                                width: '49%'
                              }}
                            >
                              <span
                                style={{
                                  display: 'inline-block',
                                  textAlign: 'right',
                                  width: '112px',
                                  float: 'left'
                                }}
                              >
                              有效期：
                              </span>
                              <span>
                                {item.begin_time
                                  ? moment(item.begin_time * 1).format(
                                    'YYYY-MM-DD'
                                  )
                                  : '--'}
                              </span>
                              <span style={{ margin: '0px 8px' }}>至</span>
                              <span>
                                {item.end_time
                                  ? moment(item.end_time * 1).format('YYYY-MM-DD')
                                  : '--'}
                              </span>
                            </div>
                          </div>

                          <div
                            key={index}
                            style={{
                              border: '1px solid lavender',
                              marginBottom: '24px',
                              padding: '16px 16px'
                            }}
                          >
                            <span
                              style={{
                                display: 'flex'
                              }}
                              className={styles.uploadimg}
                            >
                              <span>
                                {item.imgList
                                  ? item.imgList.map((j, k) => {
                                    return (
                                      <span
                                        key = {k}
                                        style={{
                                          width: '104px',
                                          height: '104px',
                                          display: 'inline-block',
                                          marginRight: '4px',
                                          border: '1px solid darkgray',
                                          position: 'relative'
                                        }}
                                      >
                                        <span className={styles.imgstyle}>
                                          <a
                                            href={j.url}
                                            className={styles.iconstyle}
                                            style={{
                                              marginRight: '8px',
                                              color: 'white'
                                            }}
                                            target="_blank"
                                          >
                                            <EyeOutlined />
                                          </a>
                                          <DeleteOutlined
                                            className={styles.iconstyle}
                                            onClick={(e) =>
                                              this.handleDeleteSixImage(
                                                e,
                                                index,
                                                k
                                              )
                                            }
                                          />{' '}
                                        </span>
                                        <img
                                          src={j.url}
                                          style={{
                                            width: '100%',
                                            height: '100%'
                                          }}
                                        ></img>
                                      </span>
                                    )
                                  })
                                  : null}
                              </span>
                              <Upload
                                action={common.scpUrl + 'item/upload-six-face'}
                                headers={{...tokenConfig}}
                                listType="picture-card"
                                data={{
                                  qua_item_id: this.state.postData.qua_item_id
                                }}
                                multiple={true}
                                accept="image/jpeg,image/jpg,image/png"
                                fileList={item.imgList ? item.imgList : []}
                                beforeUpload={
                                  this.handleBeforeUploadResponsibility
                                }

                                onChange={(e) => {
                                  this.handleChangeSixPicter(index, e)
                                }}

                              >
                                {item.imgList
                                  ? item.imgList.length > 50
                                    ? null
                                    : uploadButton
                                  : uploadButton}
                              </Upload>
                            </span>
                          </div>
                        </TabPane>
                      )
                    })
                    : null}
                </Tabs>

                {this.state.detailsVisible && (
                  <HistoryComponent
                    type={this.state.type}
                    handleVisible={this.handleVisible}
                    waringData={this.state.waringData}
                    historyData={this.state.historyData}
                    overdueData={this.state.overdueData}
                  ></HistoryComponent>
                )}

                {this.state.chooseDetails && (
                  <ManufacturerComponent
                    postData={this.state.postData}
                    chooseFirmParam={this.state.chooseFirmParam}
                    quaCategory={this.state.quaCategory}
                    getAgentRecord={this.getAgentRecord}
                    manufacturersServiceProviders={
                      this.manufacturersServiceProviders
                    }
                    tabActiveKey={this.state.tabActiveKey}
                    chooseManufacturerVisible={this.chooseManufacturerVisible}
                  ></ManufacturerComponent>
                )}

                <div
                  style={{
                    textAlign: 'center',
                    marginTop: '24px',
                    display: this.state.sixfacehide && !noResult ? 'block' : 'none'
                  }}
                >
                  <Button
                    type="primary"
                    onKeyDown={this.onKeyup}
                    loading={btnLoadings.preservationLoading}
                    onClick={(e) => this.handleClick(e, 'save')}
                  >
                保存
                  </Button>
                  <Button
                    type="primary"
                    style={{
                      marginLeft: '16px'
                    }}
                    onKeyDown={this.onKeyup}
                    onClick={(e) => this.handleClick(e, 'submit')}
                  >
                提交
                  </Button>
                  <Button
                    type=""
                    style={{
                      marginLeft: '16px'
                    }}
                    onKeyDown={this.onKeyup}
                    onClick={(e) => this.handleClick(e, 'back')}
                  >
                返回
                  </Button>
                </div>
              </div>
          }
          <Modal
            title={this.state.modalTitle}
            visible={this.state.visible}
            onOk={this.handleOk}
            width={500}
            onCancel={this.handleCancelModal}
            footer={false}
          >
            <div>
              <TextArea
                name="note"
                placeholder=""
                style={{ width: '90%' }}
                value={editData.note ? editData.note : ''}
                onChange={this.handleModalInput}
                maxLength="200"
                rows={3}
              />
            </div>

            <div style={{ textAlign: 'center', marginTop: '24px' }}>
              <Button
                type="primary"
                style={{
                  marginLeft: '16px',
                  display: this.state.approvalStatus
                }}
                onKeyDown={this.onKeyup}
                loading={btnLoadings.okLoading}
                onClick={(e) => this.handleOk(e, this.state.tabActiveKey)}
              >
                确定
              </Button>
              <Button
                type="primary"
                style={{ marginLeft: '16px' }}
                onKeyDown={this.onKeyup}
                onClick={this.handleCancelModal}
              >
                取消
              </Button>
            </div>
          </Modal>

          <Modal
            title="图片汇总"
            visible={this.state.Imagevisible}
            onOk={this.handleOk}
            width={800}
            onCancel={this.handleCancelModal}
            footer={false}
          >
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between'
              }}
            >
              {lookImageList || lookImageList.length !== 0
                ? lookImageList.map((item, index) => {
                  return (
                    <a
                      href={item.url}
                      target="_blank"
                      style={{
                        width: '104px',
                        height: '104px',
                        marginBottom: '16px'
                      }}
                      key={index}
                    >
                      <img
                        style={{ width: '100%', height: '100%' }}
                        src={item.url}
                      ></img>
                    </a>
                  )
                })
                : null}
            </div>
          </Modal>
          <BackTop visibilityHeight={40}/>
        </Spin>
      </div>
    )
  }
}
export default ManufacturerDetail



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/commodityqualification/manufacturerdetail.js